import React, { useEffect } from "react";
import { BrowserRouter as Router, Route, Routes } from "react-router-dom";
import "./App.css";
import Footer from "./components/Footer/Footer";
import Header from "./components/Header/Header";
import Home from "./components/Home/Home";
import About from "./components/About/About";
import Contact from "./components/Contact/Contact";
import Login from "./components/Login/Login";
// import { useDispatch, useSelector } from "react-redux";
// import { getUser, loadUser } from "./actions/user";
// import AdminPanel from "./components/Admin/AdminPanel";
// import Timeline from "./components/Admin/Timeline";
// import Platform from "./components/Admin/Platform";
// import Project from "./components/Admin/Project";
import Projects from "./components/Projects/Projects";
// import Loader from "./components/Loader/Loader";
const App = () => {
  // const dispatch = useDispatch();

  // const { isAuthenticated } = useSelector((state) => state.login);
  // const { loading, user } = useSelector((state) => state.user);

  // useEffect(() => {
  //   dispatch(getUser());
  //   dispatch(loadUser());
  // }, [dispatch]);
  return (
    <Router>
      {/* {loading ? (
        <Loader/>
      ) : (
        <>
           */}
      <Header />
      <Routes>
        <Route
          path="/"
          element={
            <Home
            // platforms={user.platform}
            // timelines={user.timeline}
            // skills={user.skills}
            />
          }
        />

        <Route 
        path="/about" 
        element=<About 
          // about={user.about} 
          />
         />
            <Route
              path="/projects"
              element=<Projects 
                   // projects={user.projects} 
              />
            />

            <Route 
             path="/contact"
             element=<Contact />
            />

            <Route
              path="/account"
              element=<Login />
            />
            {/* <Route
              path="/admin/timeline"
              element={isAuthenticated ? <Timeline /> : <Login />}
            /> */}
            {/* <Route
              path="/admin/platform"
              element={isAuthenticated ? <Platform /> : <Login />}
            /> */}
            {/* <Route
              path="/admin/project"
              element=
              {isAuthenticated ? <Project /> : <Login /> }
            /> */}
       
        {/* </> */}
      {/* )} */}
      </Routes>
      <Footer />
    </Router>
  );
};

export default App;
